export const genericRegex = {
  name: /^[a-zA-Z ]+$/,
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phone: {
    mobile: {
      AU: /^(?:\+?61|0)4(?:[01]\d{3}|(?:2[1-9]|3\d|4[7-8]|5[0-15-9]|6[0679]|7[3-8]|8[1478]|9[027-9])\d{2}|(?:20[2-9]|44[45]|49[0-35-9]|52[0-6]|68[3-9]|70[0-7]|72[5-9]|79[01]|80[0-28-9]|82[014-9]|83[0-38]|858|899|900|91[0-46-9]|93[01])\d|(?:201[0-2]|200[0-4]|898[45]|915[017]))\d{4}$/,
      NZ: /^(((\+?64\s*[-\.]?[3-9]|\(?0[3-9]\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{4})|((\+?64\s*[-\.\(]?2\d{1}[-\.\)]?|\(?02\d{1}\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{3,5})|((\+?64\s*[-\.]?[-\.\(]?800[-\.\)]?|[-\.\(]?0800[-\.\)]?)\s*[-\.]?\d{3}\s*[-\.]?(\d{2}|\d{5})))$/
    },
    landline: {
      AU: /^(?:\+?61( ?)|\(?0)[2378]\)?(?:[ -]?\d){8}$/,
      NZ: /^(?:\+?64( ?)|\(?0)[34679]\)?((?:[ -]?\d){7}$)/
    }
  }
};

export const validEmail = email => {
  if (!email) return false;
  return genericRegex.email.test(email);
};

/**
 * Determine if a given string is a valid name.
 * A name can not have special characters or numbers.
 *
 * @param name
 * @returns {boolean}
 */
export const validName = name => {
  if (!name) return false;
  return genericRegex.name.test(name);
};

/**
 * Validates a value against all regex within an object.
 * This is useful when trying to validate, for example, a phone number against all region specific mobile numbers using
 * {@link genericRegex.phone.mobile}.
 *
 * @param object The object of regex to test against.
 * @param value The value to validate
 * @returns {boolean} `true` if the value passed an regex in the given object.
 */
const validateAllRegexInCategory = (object, value) => {
  if (!value) return false;
  const categoryRegex = Object.values(object);
  for (let i = 0; i < categoryRegex.length; i += 1) {
    if (categoryRegex[i].test(value)) {
      return true;
    }
  }
  return false;
};

/**
 * Determines if a given phone number is a valid mobile format.
 *
 * @param phoneNumber The phone number to validate
 * @param countryCode An optional country code to specify the format of the test
 * @returns {boolean} `true` if the phone number is a mobile number
 */
export const validMobileNumber = (phoneNumber, countryCode) => {
  if (countryCode && genericRegex.phone.mobile[countryCode]) {
    return genericRegex.phone.mobile[countryCode].test(phoneNumber);
  }
  return validateAllRegexInCategory(genericRegex.phone.mobile, phoneNumber);
};

/**
 * Determines if a given phone number is a valid landline format.
 *
 * @param phoneNumber The phone number to validate
 * @param countryCode An optional country code to specify the format of the test
 * @returns {boolean} `true` if the phone number is a landline number
 */
export const validLandlineNumber = (phoneNumber, countryCode) => {
  if (countryCode && genericRegex.phone.landline[countryCode]) {
    return genericRegex.phone.landline[countryCode].test(phoneNumber);
  }
  return validateAllRegexInCategory(genericRegex.phone.landline, phoneNumber);
};

export const validLicenceNumber = str => {
  if (!str) return false;
  let characters = 0;
  let numerics = 0;
  if (str.length > 3 && str.length < 10) {
    for (let i = 0; i < str.length; i += 1) {
      if (str.charCodeAt(i) > 47 && str.charCodeAt(i) < 58) {
        numerics += 1;
      } else {
        characters += 1;
      }
    }
    if (characters > 2 && numerics < 4) {
      return false;
    }
    return (
      str.charCodeAt(2) > 47 &&
      str.charCodeAt(2) < 58 &&
      str.charCodeAt(3) > 47 &&
      str.charCodeAt(3) < 58
    );
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/utils/validators/GenericValidators.js